module.exports = function (newPost) {
  // Injected into `.actions` — compact feed-header control.
  return "\n      <button class=\"new-post saito-button-primary compact\" type=\"button\">\n        <i class=\"fa-solid fa-plus\" aria-hidden=\"true\"></i>\n        <span>Post</span>\n      </button>\n  ";
};